import React, { useState, useEffect  } from "react";
import './App.css';
import  SwitchVehiculo  from './componentes/SwitchVehiculo';
import $, { event } from 'jquery'; 
import { LoginIngreso } from './componentes/LoginIngreso';
import { LoginCierre } from './componentes/LoginCierre';
import useSound from 'use-sound';
import encendidocarro from './sonidos/encendidocarro.mp3';
import botonokc from './sonidos/botonok.mp3';
import instrucciones from './sonidos/leerinstrucciones.mp3';
import altavoz from './sonidos/altavoz.mp3';
import cierredesesion from './sonidos/cierredesesion.mp3';
import configuracions from './sonidos/configuracion.mp3';
import controlbrillo from './sonidos/controlbrillo.mp3';
import entradausb from './sonidos/entradausb.mp3';
import habilitartorniquete from './sonidos/habilitartorniquete.mp3';
import iniciarviaje from './sonidos/iniciarviaje.mp3';
import realizarfonia from './sonidos/realizarfonia.mp3';
import sensorluz from './sonidos/sensorluz.mp3';
import pantallasound from './sonidos/pantalla.mp3';
import iniciaroperacion from './sonidos/iniciaroperacion.mp3';
import viajessininiciar from './sonidos/viajessininiciar.mp3';
import enoperacion from './sonidos/pantallaenoperacion.mp3';
import cerrarsesionp from './sonidos/deseacerrarsesion.mp3';
import foniacentroc from './sonidos/foniacentrocontrol.mp3';

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';

export default function App(){

const [encendidoc] = useSound(encendidocarro);
const [linstrucciones] = useSound(instrucciones);
const [botonokcont] = useSound(botonokc);
const [cierredesesionS] = useSound(cierredesesion);
const [configuracionS] = useSound(configuracions);
const [controlbrilloS] = useSound(controlbrillo);
const [entradausbS] = useSound(entradausb);
const [habilitartorniqueteS] = useSound(habilitartorniquete);
const [iniciarviajeS] = useSound(iniciarviaje);
const [realizarfoniaS] = useSound(realizarfonia);
const [sensorluzS] = useSound(sensorluz);
const [altavozS] = useSound(altavoz);
const [pantallaS] = useSound(pantallasound);
const [iniciaroperacionS] = useSound(iniciaroperacion);
const [viajessininiciarS] = useSound(viajessininiciar);
const [enoperacionS] = useSound(enoperacion);
const [cierredesesionconfirmaS] = useSound(cerrarsesionp);
const [foniacentrocS] = useSound(foniacentroc);

const [isToggled, setIsToggled] = useState(false);
const [visibleV, setVisible]= useState(false);
const [visibleIniciarViaje, setVisibleIniciarViaje]= useState(false);
const [visibleLoginI, setVisibleLoginI]= useState(false); 
const [visibleLoginC, setVisibleLoginC]= useState(false);
const [logActivo, setLogActivo] = useState('N');
const [visiblePantalla, setVisiblePantalla]= useState(false);
const [pantalla, setPantalla]= useState('pantallaApagado.png');
const [funcion, setFuncion]= useState('teclado');
const [visibleLogin, setVisibleLogin]= useState(false);
const [visibleBotonesLlamada, setVisibleBotonesLlamada]= useState(false);
const [msgayuda, setmsgayuda]= useState('');

var pantallaL;
var pantallaC;
var pasC;

function comenzar(){
  setVisible(true)
  linstrucciones();
}

function ocultaP(){
  setVisiblePantalla(false);  
  setVisibleLoginI(false);
  setVisibleLoginC(false);
  setVisibleIniciarViaje(false);
  setVisibleBotonesLlamada(false);
}

function finalizaSesion(e){
  pasC= $('#pasC').val();
  if(pasC !=''){//console.log('-3-'); 
    setVisiblePantalla(false);  
    setVisibleLoginI(true);
    setVisibleLoginC(false); 
  }
  else{
      alert('Por favor ingrese Contraseña!'); 
  }
 
}

function login(e){ 
  setVisibleLoginC(false);
    var id_ope, pas_ope;
    id_ope = $('#id').val();
    pas_ope = $('#contrasena').val();
         
  if(id_ope != '' && pas_ope !=''){  
      setLogActivo('S');
      cargando();
      setTimeout(function(){  
      botonokcont();  
      setPantalla('inicioLoginOK.png');
      setmsgayuda('Estado: Carga de Asignacion');
      setFuncion('inicioProgramacion');    
      }, 1000);
  }
  else{
      alert('Por favor ingrese Usuario y Contraseña!'); 
  }
}
 
function inicioProgramacion(){
  ocultaP();
  setPantalla('inicioProgramacionA.gif');
  setmsgayuda('Pantalla Programacion');
  setVisiblePantalla(true); 
  viajessininiciarS();
}

function cargando(){     
ocultaP();
setVisiblePantalla(true);  
setPantalla('cargandoL.png');
setmsgayuda('Estado: Cargando');
}	

function cierraSesion(){ 
cierredesesionS();

  setTimeout(() => {
  if (isToggled){	
    if(logActivo == 'S'){
      setLogActivo('N');
      ocultaP();  
      setVisibleLoginC(true);  
      cierredesesionconfirmaS();
    }
    
}else{
    alert ('Vehiculo Apagado!'); 
}

}, 2000); 
  
}

function ejecutar(funcion){

eval( funcion+'()');
}

function viaje(){
ocultaP();
setVisiblePantalla(true);  
setPantalla('viaje.png');
setmsgayuda('Pantalla: En Viaje');
enoperacionS();
}

function prendido(){

if (isToggled){
  setIsToggled(false);
  setLogActivo('N');
  ocultaP();  
  setVisibleLoginI(true); 
  //setVisibleLogin(true);
  
  clearTimeout(tiempoinicio);
  
}else{
  setIsToggled(true);
  setLogActivo('N');
  ocultaP();  
  setVisibleLoginI(true); 
  setVisibleLogin(true);
  
  var tiempoinicio = setTimeout(() => {
      setVisibleLogin(false);
  }, 2000);  
  encendidoc();
}
}

function iniciarViaje(){

  if (isToggled){	
      if(logActivo=='S'){
        ocultaP();
        setVisibleIniciarViaje(true);
      }
  var inicioOperS = setTimeout(() => {
        iniciaroperacionS();
      }, 2000);  
      
  }else{
      alert ('Vehiculo Apagado!');
  }
  clearTimeout(inicioOperS);
  iniciarviajeS();  
}

function liberaT(){
  alert('Libera Torniquete!');
  habilitartorniqueteS();
}

function llamadaHablar(){
  ocultaP();
  setPantalla('llamadaHablar.png');
  setmsgayuda('Pantalla: En Llamada');
  setVisiblePantalla(true); 
}

function configuracion(){
  if ( logActivo=='S'){
  ocultaP();
  setPantalla('configuracion.gif');
  setmsgayuda('Pantalla: En Configuracion');
  setVisiblePantalla(true);  
  configuracionS();
}else{
  alert ('Vehiculo Apagado!'); 
}
}

function cerrarLlamada(){
inicioProgramacion();
}

function mensajeTexto(){
ocultaP();
setPantalla('enviarMensaje.png');
setmsgayuda('Pantalla: Mensaje de texto Predefinido');
setVisiblePantalla(true);
}

function llamada(){
  if ( logActivo=='S'){
    ocultaP();
    setVisiblePantalla(false);
    setVisibleBotonesLlamada(true);
    setFuncion('inicioProgramacion');  
    
    if (!isToggled){
      realizarfoniaS();
    }else{
      foniacentrocS();
    }
  }else{
    alert ('Vehiculo Apagado!'); 
  }
}

if( visibleLoginC ){  
    pantallaL =  <LoginCierre finalizaSesion={finalizaSesion} /> ;
}else if( visibleLoginI ){
    pantallaL =  <LoginIngreso login={ login }  /> ; 
}else if( visiblePantalla ){
    pantallaL =  <><b className='instrucciones'>
              <img className='imagenPantalla'       src={require('./imagenes/'+pantalla)}
        alt='imagen'    onClick={(event)=>ejecutar(funcion)} /></b>
        <span className='tooltiptext'>{msgayuda}                    
                    </span></> ;   
}else if(visibleBotonesLlamada){
      pantallaL =  <> <table >
                <tr>
                  <td><img alt=" " src="assets/images/llamada/slice_0_0.png" className="slice_0_0" /> </td>
                  <td><img alt=" " src="assets/images/llamada/slice_0_1.png" className="slice_0_1" /> </td>
                  <td><img alt=" " src="assets/images/llamada/slice_0_2.png" className="slice_0_2" /> </td>
                  <td><img alt=" " src="assets/images/llamada/slice_0_3.png" className="slice_0_3"/> </td>
              </tr>
                <tr>
                  <td><img alt=" " src="assets/images/llamada/slice_1_0.png" className="slice_1_0" /></td>
                  <td><img alt=" " src="assets/images/llamada/slice_1_1.png"  className="slice_1_1"/></td>
                  <td><img alt=" " src="assets/images/llamada/slice_1_2.png"  className="slice_1_2"/></td>
                  <td><img alt=" " src="assets/images/llamada/slice_1_3.png" onClick={ () =>cerrarLlamada() } className="slice_1_3"/></td>
              </tr>
                <tr>
                  <td><img alt=" " src="assets/images/llamada/slice_2_0.png" className="slice_2_0"/></td>
                  <td><img alt=" " src="assets/images/llamada/slice_2_1.png"  className="slice_2_1"/></td>
                  <td><img alt=" " src="assets/images/llamada/slice_2_2.png"  className="slice_2_2"/></td>
                  <td><img alt=" " src="assets/images/llamada/slice_2_3.png" className="slice_2_3"/></td>
              </tr>
                <tr>
                  <td><img alt=" " src="assets/images/llamada/slice_3_0.png" className="slice_3_0"/></td>
                  <td><img alt=" " src="assets/images/llamada/slice_3_1.png" onClick={ () =>llamadaHablar() }  className="slice_3_1" />
                  </td>
                  <td>  <b className='instrucciones'>  
                      <img alt=" " src="assets/images/llamada/slice_3_2.png" onClick={ () =>mensajeTexto() } className="slice_3_2"/>
                    </b><span className='tooltiptext'>Normal:Novedades en ruta
                                                      Urgente:Contingencia tm01,tm02
                                                      Averiado:Fallas equipo SIRCI
                                                      Mensaje:Texto Predefinido                     
                    </span>
                  </td>
                  <td><img alt=" " src="assets/images/llamada/slice_3_3.png" className="slice_3_3"/></td>
              </tr>
                <tr>
                  <td><img alt=" " src="assets/images/llamada/slice_4_0.png" className="slice_4_0"/> </td>
                  <td><img alt=" " src="assets/images/llamada/slice_4_1.png" className="slice_4_1"/> </td>
                  <td><img alt=" " src="assets/images/llamada/slice_4_2.png" className="slice_4_2"/> </td>
                  <td><img alt=" " src="assets/images/llamada/slice_4_3.png" className="slice_4_3"/> </td>
              </tr>
          </table>    
        </>;

}else if( visibleIniciarViaje ){
    pantallaL =  <div className='iniciarViaje'>
             <img className='imagenPantallaViaje1' onClick={ () =>viaje() }  src='assets/images/iniciarViaje.png'  />
             <img className='imagenPantallaViaje2' onClick={ () =>inicioProgramacion() } src='assets/images/iniciarViaje2.png' /> </div> ;	                  				   
}
 
if (isToggled){
     pantallaC = <><img className='imagenPantallaE' style={{ visibility: visibleLogin ? 'visible' : 'hidden' , height: visibleLogin ? '95%' : '0px' }}
        src={require(`./imagenes/pantallaEncendido.png`)} onClick={ function(){
          return setVisibleLogin(false) }}   
        alt='imagen' />
        <div className='divMostrarLogin' style={{ display: visibleLogin ?  'none' : 'block' , height: visibleLogin ? '0px' : '95%' }}>
         { pantallaL }   
        </div></> ;
}else{
    pantallaC = <> 
        <b className='instrucciones' onClick={(event)=>ejecutar('pantallaS')} >?</b>
        <span className='tooltiptext' >Pantalla</span>
        <img className='imagenPantallaA' src={require(`./imagenes/pantallaApagado.png`)}
        alt='imagen'
        /> </>  ;      
}

return ( 
  
  <Accordion>
     <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                       <strong>Leer</strong> 
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div><h4>1. Prender Vehiculo</h4>
                    Cuando el operador abra el switch, comenzara la inicialización de la unidad logica, una pantalla de carga
                    aparecerá y luego otra pantalla indicara que la inicialización esta completa. </div>
                  <div><h4>2. Iniciar Sesion</h4>
                    Seleccione el Campo Id, luego digite su Id TRANSMILENIO con el teclado. <br/>
                    Seleccione el Campo para la contraseña, luego digite su Contraseña tocando el teclado, finalmente presione el botón de
                    confirmación OK <img alt=" " className="btnok" src="./assets/images/check.png" />. Luego apareceran los datos de operador y dos lineas en color verde indicando la carga de datos.<br/>
                    Recuerde verificar que los iconos de la parte superior se encuentren de color verde, esto indicara correcto funcionamiento.   
                </div>
                <div><h4>3. Confirmar Datos</h4>Cuando el inicio de sesión es exitoso, los servicios y los
                  datos de operación seran descargados de la red.<br/>
                  Cuando el servicio y los datos son completamente descargados,
                  vera dos rayas verdes en la pantalla, oprima el boton
                  confirmacion y espere el Inicio de sesión..<img alt=" " src="images/check.png" />
                </div>
                <div><h4>4. Ver Programacion</h4>
                  La pantalla muestra la programacion del conductor, puede  revisar la información del cronograma como: nombre de ruta,
                  lugar de salida, lugar de llegada, etc.<br/>
                  Utilice la barra para desplazarse, puede revisar el estatus del tiempo de salida, tiempo restante de servicio, tiempo de
                  operación, distancia de operación ó estado, hacer una llamada al centro control ó volver a la pantalla de configuración. </div>
                <div><h4>5. Iniciar Viaje</h4>
                  En la pantalla cronograma seleccione el viaje que va
                  iniciar y oprima la tecla <strong>F2</strong> para comenzar un viaje, luego debe
                  oprimir el boton confirmar para comenzar el viaje, luego vera la pantalla de inicio de operacion.
                  <img alt=" " className="btnok" src="images/check.png" />
                </div>
                <div><h4>6. Teclas de Funcion</h4><br/>
                <strong>F1 </strong>- Esta tecla le permite cerrar la sesion, Siempre antes de apagar el vehiculo Cierre su sesion. <br/>
                <strong>F2 </strong>- Esta tecla permite iniciar operacion, para comenzar la operacion debe oprimir esta tecla y confirmar viaje. <br/>
                <strong>F3 </strong>- Esta tecla le permite liberar el torniquete.<br/>
                <strong>F4 </strong>- Esta tecla le permite comunicarse con el centro de control, hacer una llamada o enviar un mensaje para notificar una situacion. <br/>
                <strong>F5 </strong>- Esta tecla le permite validar la configuracion de los sensores y la unidad logica.<br/>
                </div>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                        <strong>Observar</strong>
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                   <div  className=''>
                      <video height="400" width="600" controls>
                      <source src="./assets/videos/videoUnidadLogica.mp4" type="video/mp4" />
                       Your browser does not support the video tag.
                      </video>
                    </div>

                </AccordionItemPanel>
            </AccordionItem>
  <AccordionItem>
      <AccordionItemHeading>
          <AccordionItemButton>
          <strong>Practicar</strong>
          </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
      <div className='App'>  
     <div className='contenedorInicio' style={{display: visibleV ? 'none' : 'block' , height: visibleV ? '0' : '340px' }}  >
     <h3>A continuacion podra SIMULAR el funcionamiento de la Unidad Logica<br/> <b className='instrucciones'>Escuche Atentamente las Indicaciones,</b><br/> Utilíze los simbolos de ayuda <b className='instrucciones'>?</b> para conocer los elementos  y consultar la guia de los botones <b className='instrucciones'>F</b></h3> 
     <button className='botonInicio' onClick={ comenzar }><h1>Inicio</h1></button> 
      </div>
       <div className='contenedorUnidadLogica' style={{ display: visibleV ? 'block' : 'none' }} >
        <div className='contenedorSuperior'>
          <div className='contenedorMicro'>
            <div className='microfono' onClick={(event)=>ejecutar('altavozS')} >
            ...<b className='instrucciones' >?</b> <br/>...<br/>...<span className='tooltiptext'>Altavoz</span></div>
            <div>&nbsp;</div>
            <div className='puertousb' onClick={(event)=>ejecutar('entradausbS')}>...<b className='instrucciones'>?</b> <br/>|&nbsp;|<br/>...<span className='tooltiptext'>Entrada usb</span></div> 
           </div>   
           <div className='contenedorPantalla'  >
                 { pantallaC }
           </div>
          <div className='contenedorSensor' >
          <div className='sensorluz' onClick={(event)=>ejecutar('sensorluzS')}> *<b className='instrucciones'>?</b><span className='tooltiptext'>Sensor<br/> Luz</span></div>  
          <div>&nbsp;</div>
            <div className='controlbrillo' onClick={(event)=>ejecutar('controlbrilloS')}>|&#8593;|<b className='instrucciones'>?</b><br/>|&#8595;|<br/> <span className='tooltiptext'>Control<br/> Brillo</span></div>            
             </div>
          </div>
        <div className='contenedorBotones'>
          <div className='botonFuncion'  onClick={(event)=> cierraSesion()} >F1 <b className='instrucciones'>?</b><span className='tooltiptext'>Cierre de<br/>Sesion</span></div>
          <div className='botonFuncion' onClick={(event)=>iniciarViaje()} >F2 <b className='instrucciones'>?</b><span className='tooltiptext'>Iniciar<br/>Viaje</span></div>
          <div className='botonFuncion' onClick={(event)=>liberaT()} >F3 <b className='instrucciones'>?</b><span className='tooltiptext'>Habilitar<br/>Torniquete</span></div>
          <div className='botonFuncion' onClick={(event)=>llamada()} >F4 <b className='instrucciones'>?</b><span className='tooltiptext'>Realizar<br/>Fonia</span></div>
          <div className='botonFuncion' onClick={(event)=>configuracion()} >F5 <b className='instrucciones'>?</b><span className='tooltiptext'>Configuracion</span></div>
        </div>
      </div>
      <div className='contenedorSwitch' style={{ visibility: visibleV ? 'visible' : 'hidden' }} >
        Para que funcione la unidad logica debe Abrir el switch del vehiculo: <b className='instrucciones'>Abrir Switch</b>  &#10137; Off 
        <SwitchVehiculo isToggled={isToggled} onToggle={() => prendido() } />On         
      </div>
      </div>
      
      </AccordionItemPanel>
  </AccordionItem>
  <AccordionItem>
      <AccordionItemHeading>
          <AccordionItemButton>
          <strong> Preguntas Frecuentes</strong>
          </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>

      <div className="preguntafaq">
          <div className="preguntafaq">
          <h4>1. Como Subir el Volumen de Unidad ?</h4><br />
           Al oprimir la tecla f5 vera la pantalla de configuracion, puede tocar 
           la pantalla en la zona señalada para subir el volumen.
          </div>
          <div className="preguntafaq">   
          <img src="./assets/images/subirVolumen.png" alt=" " title=" " className="imagenp"/>
          <br />
          </div>
         <div className="preguntafaq"><h4>2. Que Significan los Iconos?</h4><br /></div>
         <div className="preguntafaq"><img src="./assets/images/iconos.png" alt="Iconos" title="Iconos" className="imagenconvenciones"/><br />
          </div>
         <div className="preguntafaq"><img src="./assets/images/convencionesP.png" alt="convenciones" title="convenciones" className="imagenconvenciones"/><br />
          </div>
          <div className="preguntafaq"><br />
          Según la ubicación del vehiculo, el estado e ícono aparecen en el medio de la pantalla de programación y el color del bus va cambiando dependiendo de la distancia entre buses.
          <br /><br />				
          <img src="./assets/images/iconosBusUbicacion.png" alt="Iconos" title="Iconos" className="imagenbus"/><br />
          </div><br />
          <div className="preguntafaq"><br /><h4> 3. Cuales son los Sensores ?</h4></div>
          <div className="preguntafaq"><img src="./assets/images/validador.png" alt="Validador" title="Validador" className="imagenp" />
            <h4>Validador</h4><br />Al inicio se muestra la hora actual, significa que el validador fue iniciado normalmente, en caso contrario informe el incidente.<br />
            El validador descuenta  la tarifa, muestra el saldo de la Tarjeta, reconoce el tipo de tarjeta de transporte, sincroniza el tiempo.<br />
          </div>
          <div className="preguntafaq"><img src="./assets/images/torniquete.png" alt="Torniquete" title="torniquete" className="imagenp" />
            <h4>Torniquete</h4><br />
            Si el pasajero ha validado la tarjeta, la entrada del torniquete es habilitada y el pasajero puede entrar empujándolo, 
            en el modo de emergencia, ambos sentidos del torniquete son habilitados. Cuando regresa al estado normal, serán cerrados nuevamente.
  <br />
          </div>
          <div className="preguntafaq"><img src="./assets/images/sensorpuerta.png" alt="Sensor Puerta" title="sensorpuerta" className="imagenp"/>
            <h4>Sensor Puerta</h4>Si alguna de las puertas del bus se encuentra abierta podra observar un aviso en la unidad logica.
  <br />
          </div>
          <div className="preguntafaq"><br /><h4>4. Manejo de Fallas:</h4> </div>
          <div className="preguntafaq">
  <h4>Sin Datos</h4><br />
  Si observa una imagen como esta en la unidad logica, indicara que no hay comunicacion,  
  aún sin comunicación, el bus está en capacidad de operar.
  En este caso, al presionar el botón de OK se transferirá a la pantalla operativa.
  <br />
  <img src="./assets/images/pantallaSinDatos.png" alt="sindatos" title="sindatos" className="imagenp" />
    <br />
          </div>
          <div className="preguntafaq">
  <h4>Forma correcta de utilizar la pantalla Tactil</h4><br />
  
  <img src="./assets/images/manoPantallaTactil.png" alt=" " title=" " />
  <br />
          </div>
         <div className="preguntafaq"><br />
           <h4>Falla Puertas Abiertas</h4><br />
            El sensor no funciona por alejamiento del iman, cuando se realizan
          cambios o arreglos de las hojas de las puertas y cambio de los sistema
          hidráulicos que permiten el cierre y la apertura de la puerta, puede presentarse
          falla por alejamiento de las puertas, se puede observar como en la 
          imagen 1 y el sensor se ve como en la Imagen 2.
          <br />
          <img src="./assets/images/puertaAbierta1.png" alt="imagen1" title="imagen1" className="imagenp"/>
          <img src="./assets/images/puertaAbierta2.png" alt="imagen2" title="imagen2" className='imagenp'/>
  <br /> 
   <br /><br /><br /><br /><br /><br /><br /><br />
  De esta forma el sensor estará alarmado y enviara un mensaje a la
  consola que dirá puerta # abierta aunque esté cerrada, el modo
  correcto es como en la imagen 3, esta falla debe ser reportada para generar un ticket.          
  <br />
  <img src="./assets/images/puertaCerrada.png" alt="imagen3" title="imagen3" className="imagenp" />
  <br />
          </div>
          <div className="preguntafaq">
            <h4>Sensor sin iman</h4><br />
            Cada vez que esto pase debe ser reportado para generar un ticket
            y realizar el cambio del equipo. Esto se debe a que el imán es
            el complemento del sensor.<br /><br />

            Si la consola informa PUERTA # abierta, informe la falla
            a la cual corresponde, es decir observe que puerta está en falla, y
            verifique si es realmente el sensor, ya sea sin imán o muy alejado
            para poder abrir un ticket, si es por hojas observe la falla e informe
            al encargado del patio.<br /><br />
              </div>
        </div>
           
      </AccordionItemPanel>
  </AccordionItem>
  </Accordion>
  
  );
}